import { render, staticRenderFns } from "./Endorsements.vue?vue&type=template&id=5e940572&"
import script from "./Endorsements.vue?vue&type=script&lang=ts&"
export * from "./Endorsements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e940572')) {
      api.createRecord('5e940572', component.options)
    } else {
      api.reload('5e940572', component.options)
    }
    module.hot.accept("./Endorsements.vue?vue&type=template&id=5e940572&", function () {
      api.rerender('5e940572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/Endorsements.vue"
export default component.exports